module.exports = __webpack_public_path__ + "static/media/riskScoreOne.88bce352.mp3";